import React from "react";

interface AeroInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const AeroInfoModal: React.FC<AeroInfoModalProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 50,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                paddingTop: 64,
            }}
        >
            {/* Overlay — black 60% opacity, no blur */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "#000",
                    opacity: 0.6,
                }}
            />

            {/* Modal card — 480px, 16px radius, 32px padding, positioned near top */}
            <div
                style={{
                    position: "relative",
                    backgroundColor: "#fff",
                    borderRadius: 16,
                    width: 480,
                    maxWidth: "calc(100% - 32px)",
                    padding: 32,
                    fontFamily:
                        '"Haas Grot Disp Web", "Haas Grot Text Web", "Helvetica Neue", Helvetica, Arial, sans-serif',
                }}
            >
                {/* Heading — 24px, weight 400 */}
                <span
                    style={{
                        display: "block",
                        fontSize: 23,
                        fontWeight: 400,
                        lineHeight: "28px",
                        color: "#000",
                        marginBottom: 16,
                    }}
                >
                    Pre-boarding screening
                </span>

                {/* TSA paragraph */}
                <p
                    style={{
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        color: "#000",
                        margin: "0 0 12px 0",
                    }}
                >
                    Starting July 14, 2025, the TSA requires enhanced screening
                    for all public charter operators, including Aero. To ensure
                    a smooth experience, please place liquids over 3.4oz in
                    checked baggage. You can find details on what to expect{" "}
                    <a
                        href="https://help.aero.com/hc/en-us/articles/39137074133908"
                        target="_blank"
                        rel="noopener noreferrer"
                        ref={(el) => {
                            if (el)
                                el.style.setProperty(
                                    "color",
                                    "#1255cc",
                                    "important",
                                );
                        }}
                        style={{
                            textDecoration: "underline",
                            textUnderlineOffset: "2px",
                        }}
                    >
                        here
                    </a>
                    .
                </p>

                {/* Real ID heading — 24px, weight 400 */}
                <span
                    style={{
                        display: "block",
                        fontSize: 23,
                        fontWeight: 400,
                        lineHeight: "28px",
                        color: "#000",
                        marginBottom: 16,
                        marginTop: 16,
                    }}
                >
                    Real ID{" "}
                </span>

                {/* Real ID paragraph */}
                <p
                    style={{
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        color: "#000",
                        margin: "0 0 24px 0",
                    }}
                >
                    Guests aged 18+ must present a REAL ID compliant driver's
                    license or another TSA-accepted form of identification to
                    board their flight. Visit{" "}
                    <a
                        href="https://aero.com/real-id"
                        target="_blank"
                        rel="noopener noreferrer"
                        ref={(el) => {
                            if (el)
                                el.style.setProperty(
                                    "color",
                                    "#1255cc",
                                    "important",
                                );
                        }}
                        style={{
                            textDecoration: "underline",
                            textUnderlineOffset: "2px",
                        }}
                    >
                        aero.com/real-id
                    </a>{" "}
                    for more information.
                </p>

                {/* Ok button — not full width, 72px tall, border-radius 8px */}
                <button
                    onClick={onClose}
                    style={{
                        display: "inline-block",
                        width: "100%",
                        height: 72,
                        padding: "24px 16px",
                        backgroundColor: "#000",
                        color: "#fff",
                        fontSize: 16,
                        fontWeight: 500,
                        borderRadius: 8,
                        border: "2px solid #000",
                        cursor: "pointer",
                    }}
                >
                    Ok
                </button>
            </div>
        </div>
    );
};

export default AeroInfoModal;
